import { lazy, Suspense, useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AROHSPrivateRoute from "./Components/PrivateRoutes/AROHSPrivateRoute";
import "./App.css";
import { messaging, getToken, onMessage } from "./firebase";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import UnAuthorisedAccess from "./PrivateRoutes/UnAuthorisedAccess";
const RoutingConfig = lazy(() => import("./Components/RoutingConfig"));
const Login = lazy(() => import("./Components/Auth/Login"));
const LandingPage = lazy(() => import("./Components/Auth/LandingPage"));
const ClinicLogin = lazy(() => import("./Components/Auth/ClinicLogin"));
const PhysicianLogin = lazy(() => import("./Components/Auth/PhysicianLogin"));
const PhysicianRegistration = lazy(() => import("./Components/PracticeManagement/Main/Masters/Physician/PhysicianOnBoarding/PhysicianRegistration"));
const EnterOrgDetails = lazy(() => import("./Components/Organization/EnterOrgDetails"));
const OrgDetailsFinalSubmit = lazy(() => import("./Components/Organization/OrgDetailsFinalSubmit"));

const App = () => {
  const [notification, setNotification] = useState(null);
  useEffect(() => {
    // Request permission for notifications
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        getToken(messaging, { vapidKey: "BK4YrTzPUiQmJvLwZ8SSCGr_9GTlgIP_FBf7Gs3EPt-1LUKqmvdVQ6S9myNnO7Bvcpc5L1DyIDZE_VIl7NJ2jTk" })
          .then((currentToken) => {
            if (currentToken) {
              sessionStorage?.setItem("firebaseKey", currentToken);
              console.log("FCM Token:", currentToken);
            } else {
              console.log("No registration token available.");
            }
          })
          .catch((err) => {
            console.error("An error occurred while retrieving token:", err);
          });
      }
    });
    // Handle foreground messages
    onMessage(messaging, (payload) => {
      console.log("Message received:", payload);
      setNotification(payload.notification);
      // Show system notification
      if (Notification.permission === "granted" && payload.notification) {
        new Notification(payload.notification.title, {
          body: payload.notification.body,
          icon: payload.notification.image || "/favicon.ico",
        });
      }
    });
  }, []);

  return (
    <div>
      <div>
        {/* <GoogleReCaptchaProvider reCaptchaKey="6Lc2QG4rAAAAAMAbaEax0GAFfGSydmVjv7Anztuj"> */}
        <Suspense fallback={<div className="loading-indicator">Loading...</div>}>
          <ToastContainer />
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              {/* <Route path="" element={<LandingPage />} /> */}
              <Route path="*" element={<Login />} />
              <Route path="/register-clinician" element={<ClinicLogin />} />
              <Route path="/physician-login" element={<PhysicianLogin />} />
              <Route path="physician-registration" element={<PhysicianRegistration />} />
              {/* <Route path="sessionexpired" element={<UnAuthorisedAccess />} /> */}
              <Route path="enter-org-details" element={<EnterOrgDetails />} />
              <Route path="submission-confirmation" element={<OrgDetailsFinalSubmit />} />

              <Route
                path="v1/*"
                element={
                  // <AROHSPrivateRoute>
                    <RoutingConfig />
                  // </AROHSPrivateRoute>
                }
              />
            </Routes>
          </Router>
        </Suspense>
        {/* </GoogleReCaptchaProvider> */}
      </div>
    </div>
  );
};

export default App;
